import { render, staticRenderFns } from "./ItemListEditionItemLayout.vue?vue&type=template&id=46848c8a&scoped=true"
import script from "./ItemListEditionItemLayout.vue?vue&type=script&lang=js"
export * from "./ItemListEditionItemLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46848c8a",
  null
  
)

export default component.exports